<script>
  import { createEventDispatcher, getContext } from 'svelte';
  import Url from '@utils/url';
  import ComponentEvents from '@utils/component-events';

  import Reviews from './parts/Reviews.svelte';
  import Categories from './parts/Categories.svelte';
  import Rating from './parts/Rating.svelte';
  import Photos from './parts/Photos.svelte';
  import Like from './parts/Like.svelte';

  import CategoriesModal from '@app-components/modal/CategoriesModal.svelte';
  import RecObjectOptionMenu from '@app-components/RecObjectOptionMenu.svelte';
  import BookmarkButton from '@app-components/BookmarkButton.svelte';
  import { browser } from '$app/environment';
  import BrowserUtils from '@utils/browser-utils';

  const dispatch = createEventDispatcher();

  import { getGroupStore } from '@stores/group';
  import HideReportedContentOverlay from '@app-components/report/HideReportedContentOverlay.svelte';
  let commentStore = getGroupStore('commentStore');

  export let group;
  export let recObject;
  export let recs = [];
  export let customGroupStore;

  export let showActionBar = true;
  export let showReviews = true;
  export let showBottomBar = true;
  export let showShareCard = true;
  export let style = '';
  export let columnView = false;
  export let singleLineNameOnly;
  export let detailViewEnabled = true;
  export let displayRecObjectDetailView;
  export let forceShowNames = false;
  export let showWeblinkPreview = false;

  let showCategoriesModal = false;
  let trackThenGoToRating;
  let focusBrokenLink = false;
  let reviewsExpanded = false;
  let optionsMenu;

  let toggleLike;
  let toggleBookmark;

  let reportedContentKey = `rec_${recObject.id}`;
  let reportedContent = getContext('reportedContent');
  $: reportedContentId = $reportedContent[reportedContentKey] || null;

  let dispatchFullRecObjectRendered = () => {
    dispatch('rec-object-fully-rendered');
  };

  const onClick = (event, afterDisplay) => {
    if (!reviewsExpanded) {
      displayRecObjectDetailView(event, afterDisplay);
      ComponentEvents.trigger('rec-object-click', { recObject });
    }
  };

  const onHover = () => {
    ComponentEvents.trigger('rec-object-hover', { recObject });
  };

  const onLeave = () => {
    ComponentEvents.trigger('rec-object-unhover', { recObject });
  };

  const setReviewsExpand = (e) => {
    reviewsExpanded = e.detail;
  };
</script>

<style style="text/scss" lang="scss">
  .content-clickable {
    cursor: pointer;

    &:hover {
      box-shadow: 0px 13px 40px rgba(0, 0, 0, 0.18);
    }
  }

  .no-bottom-bar {
    height: 490px !important;
  }

  .rec-object {
    height: 522px;
    width: 380px;
    background: #ffffff;
    box-shadow: 0px 13px 40px rgba(0, 0, 0, 0.0938593);
    border-radius: 15px;
    padding: 30px;
    position: relative;

    &.broken-link {
      padding-top: 0; /* will discuss*/
    }

    &.rec-object--column {
      width: 100%;
      margin-top: 20px;
      padding: 20px;
      height: unset;

      .rec-object-content {
        height: unset;

        .rec-object-name-and-rating {
          max-height: unset;
          min-height: unset;
          margin-top: 0px;
          margin-bottom: 8px;
        }

        .rec-object-categories-container {
          margin-top: 2px;
        }

        .rec-object-name1 {
          font-size: 16px;
          line-height: 22px;
        }

        .rec-object-name2 {
          font-size: 14px;
          line-height: 20px;
        }

        .rec-object-photos {
          margin-top: 12px;
        }
      }
    }

    &.rec-object-single-line-name-only {
      height: 498px;

      .rec-object-content {
        height: 336px;
        &.broken-links {
          height: 304px;
        }
      }

      .rec-object-photos {
        margin-top: 24px !important;
      }

      :global(.ui-single-photo) {
        margin-top: 8px;
      }
    }

    .rec-object-content {
      margin-top: 20px;
      background: #f5f3fc;
      border-radius: 15px;
      padding: 20px;
      width: 100%;
      height: 360px;
      display: flex;
      flex-direction: column;
      &.broken-links {
        height: 328px;
      }

      .rec-object-categories-container {
        margin-top: 10px;
      }

      .rec-object-name-and-rating {
        margin-top: 5px;
        display: flex;
        min-height: 48px;
        max-height: 48px;

        .name1Only {
          .rec-object-name1 {
            max-height: 72px;
          }
        }

        .name1and2 {
          .rec-object-name1 {
            max-height: 48px;
            -webkit-line-clamp: 1 !important;
          }
        }

        .rec-object-names {
          flex: 1;

          .rec-object-name1 {
            font-weight: 500;
            font-size: 18px;
            line-height: 24px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }

          .rec-object-name2 {
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            opacity: 0.5;
            margin-top: 6px;
            max-height: 18px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }
        }

        .rec-object-rating {
          flex-shrink: 0;
          margin-left: 20px;
          margin-top: 0px !important;
          cursor: pointer;
          margin: -5px;
          margin-left: 20px;

          &:hover {
            border-radius: 8px;
            padding-bottom: 8px;
            margin-bottom: -13px;
            background: #eae4ff;
          }
        }
      }

      .rec-object-weblink {
        margin-top: 6px;
        margin-bottom: 0px;
        a {
          color: #6b5bd2;
          font-weight: 500;
          font-size: 14px;
          text-decoration: none;
          display: inline-block;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        a:hover {
          color: #7054dc;
          text-decoration: underline;
        }
      }

      .rec-object-photos {
        margin-top: auto;
        margin-bottom: 10px;
      }
    }

    .ui-bottom-bar {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: default;
      position: relative;
      margin-top: 14px;
      gap: 4px;

      .ui-bottom-bar-action {
        padding: 8px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 34px;

        &:hover {
          background: #ececec;
        }
      }
    }
  }

  .move-pointer {
    cursor: grab;
    cursor: -webkit-grab;
  }

  .broken-link-top {
    width: calc(100% + 60px);
    margin-left: -30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px 12px 12px; /* will update*/
    gap: 10px;
    background: #ff5567;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    border-radius: 8px 8px 0px 0px;
    // position: relative;

    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0px;
      gap: 10px;
      font-weight: 600;

      .icon-alert {
        width: 16px;
      }
    }
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0px;
      gap: 12px;

      .link-button-edit {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        &:hover {
          color: lightgrey !important;
          svg {
            path {
              fill: lightgrey !important;
            }
          }
        }

        .icon-edit {
          width: 12px;
        }
      }

      .vertical-line {
        width: 1px;
        height: 16px;
        background: #ececec;
      }
    }
  }
  .broken-links-reviews-wrapper {
    margin-top: 14px;
  }
</style>

<div>
  {#if showCategoriesModal}
    <CategoriesModal recObjectId={recObject.id} bind:showModal={showCategoriesModal} />
  {/if}

  <div
    class:content-clickable={detailViewEnabled}
    class:move-pointer={!detailViewEnabled && group.permissions.edit}
    class:rec-object-single-line-name-only={singleLineNameOnly}
    use:dispatchFullRecObjectRendered
    data-rec-object-id={recObject.id}
    class:rec-object--column={columnView}
    class="rec-object rec-object-grid-view {recObject.weblink_broken ? 'broken-link' : ''}"
    class:no-bottom-bar={!showBottomBar}
    id="grid-rec-object-{recObject.id}"
    style={style}
    on:click={onClick}
    on:mouseenter={onHover}
    on:mouseleave={onLeave}>
    {#if browser && showActionBar}
      {#if recObject.weblink_broken}
        <div class="broken-link-top broken-link-rec-object">
          <div class="left">
            <img class="icon-alert" src="/images/alert-white.png" width="16px" />
            Broken Link
          </div>
          <div class="right">
            <div
              class="link-button-edit"
              on:click|preventDefault|stopPropagation={() => {
                focusBrokenLink = true;
                optionsMenu.displayRecObjectFormModal();
              }}>
              <svg
                class="icon-edit"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 9.49965L0 12H2.50035L9.87804 4.62231L7.37769 2.12196L0 9.49965ZM11.805 2.69537C12.065 2.43534 12.065 2.01195 11.805 1.75191L10.2481 0.195027C9.98806 -0.065009 9.56466 -0.065009 9.30463 0.195027L8.08446 1.4152L10.5848 3.91554L11.805 2.69537Z"
                  fill="white" />
              </svg>
              Fix
            </div>
            <div class="vertical-line" />
            <RecObjectOptionMenu
              customGroupStore={customGroupStore}
              showShareCard={showShareCard}
              bind:this={optionsMenu}
              recObjectId={recObject.id}
              bind:focusBrokenLink={focusBrokenLink}
              styleAsBrokenLink={true}
              on:removed={(e) => dispatch('removed', e.detail)} />
          </div>
        </div>
      {:else}
        <RecObjectOptionMenu
          customGroupStore={customGroupStore}
          showShareCard={showShareCard}
          recObjectId={recObject.id}
          on:removed={(e) => dispatch('removed', e.detail)} />
      {/if}
    {/if}

    <div>
      {#if showReviews}
        <div class={recObject.weblink_broken ? 'broken-links-reviews-wrapper' : ''}>
          <Reviews
            forceShowNames={forceShowNames}
            customGroupStore={customGroupStore}
            recObjectId={recObject.id}
            recIds={recs.map((x) => x.id)}
            expand={reviewsExpanded}
            on:reviewsExpand={setReviewsExpand}
            on:click={onClick} />
        </div>
      {/if}

      <div class="rec-object-content {recObject.weblink_broken ? 'broken-links' : ''}">
        <div class="rec-object-name-and-rating">
          <div class="rec-object-names name1Only">
            <div class="rec-object-name1">
              {@html recObject.name1}
            </div>
          </div>

          {#if browser && group.show_review_sites}
            <div class="rec-object-rating" on:click|preventDefault|stopPropagation={trackThenGoToRating}>
              <Rating
                customGroupStore={customGroupStore}
                bind:trackThenGoToRating={trackThenGoToRating}
                recObjectId={recObject.id} />
            </div>
          {/if}
        </div>

        {#if recObject.categories.length > 0}
          <div class="rec-object-categories-container">
            <Categories
              recObjectId={recObject.id}
              clickable={false}
              viewStyle="grid"
              showAllCategories={() => (showCategoriesModal = true)} />
          </div>
        {/if}

        {#if showWeblinkPreview && recObject.weblink}
          <div class="rec-object-weblink">
            <a href={recObject.weblink} target="_blank" rel="noopener noreferrer"
              >{Url.urlWithoutHttpsOrWww(recObject.weblink)}</a>
          </div>
        {/if}

        <div class="rec-object-photos">
          <Photos
            customGroupStore={customGroupStore}
            mobile={columnView}
            recObjectId={recObject.id}
            useFancyBox={false}
            preventDefaultClick={true}
            viewStyle="grid"
            maxBigDotsShown={7} />
        </div>
      </div>
    </div>

    {#if showBottomBar}
      <div class="ui-bottom-bar">
        {#if browser && group.show_likes}
          <div class="ui-bottom-bar-action" on:click|preventDefault|stopPropagation={() => toggleLike()}>
            <Like
              bind:toggleLike={toggleLike}
              customGroupStore={customGroupStore}
              recObjectId={recObject.id}
              viewStyle="grid" />
          </div>
        {/if}

        {#if group.show_comments}
          <div
            class="ui-bottom-bar-action"
            on:click|preventDefault|stopPropagation={(event) => {
              let focusAndScroll = async function () {
                let elem = document.querySelector('.detail-comment-label');
                let container = document.querySelector('.detail-scrollable-notes-comments');
                setTimeout(async () => {
                  await BrowserUtils.goToElementWithinContainer(elem, container, {
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'center',
                  });
                }, 0);
              };
              onClick(event, focusAndScroll);
              commentStore.set({ startFocused: true, context: 'rec' });
            }}>
            <svg
              height="18"
              class="rec-object-comment-btn"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              fill="none">
              <path
                d="M9 1C4.584 1 1 4.20129 1 8.20291C1.01196 9.165 1.22668 10.1137 1.63012 10.9872C2.03357 11.8606 2.61667 12.639 3.34133 13.2716L3.13333 16.5583C3.12961 16.6358 3.14736 16.7129 3.18462 16.7809C3.22188 16.849 3.27721 16.9055 3.3445 16.9441C3.41179 16.9827 3.48843 17.002 3.56598 16.9998C3.64353 16.9977 3.71898 16.9741 3.784 16.9318L6.584 15.0644C7.36961 15.2897 8.18273 15.4047 9 15.4058C13.416 15.4058 17 12.2045 17 8.20291C17 4.20129 13.416 1 9 1Z"
                stroke="#1A1A1A"
                stroke-width="1.5"
                class="s-RLud9ny07R5l" />
            </svg>
            {#if recObject.comments && recObject.comments.total > 0}
              <span style="color: #000; font-weight: 500; font-size: 14px; margin-left: 8px; margin-top: 1px;">
                {recObject.comments.total}
              </span>
            {/if}
          </div>
        {/if}

        <div style="flex: 1; cursor: pointer;" />

        <div class="ui-bottom-bar-action" on:click|preventDefault|stopPropagation={() => toggleBookmark()}>
          <BookmarkButton viewStyle="rec-object" rec={recs[0]} mobile={false} bind:toggleBookmark={toggleBookmark} />
        </div>
      </div>
    {/if}
  </div>

  {#if reportedContentId}
    <HideReportedContentOverlay
      text="Show Rec"
      reportedContentId={reportedContentId}
      reportedContentKey={reportedContentKey} />
  {/if}
</div>
